import { Organization, Owner } from "./ControlPanel";
import { AccessLevel } from "./generics";

export type DatasourceType = 'database' | 'messageBroker' | 'fileSystem' | 'objectStorage';

export class Datasource {
  id?: number;
  name: string;
  description: string;
  type: DatasourceType;
  host: string;
  port?: number;
  driverType: string;
  accessLevel: AccessLevel;
  other?: any[];
  organization?: Organization;
  owner?: Owner;
  createDateTime?: string;
  updateDateTime?: string;
  default?: boolean;

  accessKey?: string;
  secretKey?: string;
  bucket?: string;
  secure?: boolean;

  prefixPath?: string;

  constructor() {
    this.name = "";
    this.description = "";
    this.type = "database"; // messageBroker | fileSystem | objectStorage
    this.host = "";
    this.port = undefined;
    this.driverType = "";
    this.accessLevel = AccessLevel.TEAM;
  }
}

export class DatabaseDatasource extends Datasource {
  protocol: string;
  catalog: string;
  table: string;
  database: string;
  keyServerConfig: any;
  user?: string;
  password?: string;
  catalogue?: string;
  thriftHost?: string;
  thriftPort?: string;

  constructor() {
    super();
    this.protocol = "";
    this.catalog = "";
    this.table = "";
    this.database = "";
    this.keyServerConfig = null;
  }
}

export class FileSystemDatasource extends Datasource {
  path: string;
  extension: string;
  filename: string;

  constructor() {
    super();
    this.path = "";
    this.extension = "";
    this.filename = "";
  }
}
export class MessageBrokerDatasource extends Datasource {
  brokers: string;
  username: string;
  password: string;
  cafile?: string;
  certfile?: string;
  keyfile?: string;
  keyServerConfig?: string;

  constructor() {
    super();
    this.brokers = "";
    this.username = "";
    this.password = "";
  }
}
export class ObjectStorageDatasource extends Datasource {
  accessKey: string;
  secretKey: string;
  bucket: string;
  prefixPath: string;
  regionName?: string;
  secure: boolean;

  constructor() {
    super();
    this.accessKey = "";
    this.secretKey = "";
    this.bucket = "";
    this.prefixPath = "";
    this.secure = false;
  }
}